export const PLAN_BOX_TYPE = {
  OPTION: "OPTION",
  CART_ITEM: "CART_ITEM",
};
